import { cx, styled } from "simplydo/react/styled";

import type { CardDescriptionProps } from "./Card.types";

const DescriptionEl = styled.div`
  clear: both;
  color: rgba(0, 0, 0, 0.68);
  margin-top: 0.5em;
`;

const CardDescriptionComponent = (props: CardDescriptionProps) => {
  const { children, className, style } = props;
  return (
    <DescriptionEl className={cx(className)} style={style}>
      {children}
    </DescriptionEl>
  );
};

export const CardDescription = styled(CardDescriptionComponent)``;
